import { render, staticRenderFns } from "./collegeDirector.vue?vue&type=template&id=5ceb6d53&scoped=true&"
import script from "./collegeDirector.vue?vue&type=script&lang=js&"
export * from "./collegeDirector.vue?vue&type=script&lang=js&"
import style0 from "./collegeDirector.vue?vue&type=style&index=0&id=5ceb6d53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceb6d53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VIcon,VImg})
